import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";

export default function GestoreLegal() {
  const [terms, setTerms] = useState(undefined);
  const [privacy, setPrivacy] = useState(undefined);
  const [dpa, setDpa] = useState(undefined);
  const [acc, setAcc] = useState([]);

  useEffect(() => {
    api.get("/public/legal/terms").then((r) => setTerms(r.data?.id ? r.data : null)).catch(() => setTerms(null));
    api.get("/public/legal/privacy").then((r) => setPrivacy(r.data?.id ? r.data : null)).catch(() => setPrivacy(null));
    api.get("/public/legal/dpa").then((r) => setDpa(r.data?.id ? r.data : null)).catch(() => setDpa(null));
    api.get("/legal/my-acceptances").then((r) => setAcc(r.data)).catch(() => {});
  }, []);

  const Row = ({ label, doc, to }) => (
    <div className="flex items-center justify-between border-b border-[#F0EAE1] py-3" data-testid={`gestore-legal-${label.toLowerCase()}`}>
      <div>
        <p className="text-sm font-semibold text-[#1B3B2B]">{label}</p>
        <p className="text-xs text-[#5F6B64]">{doc === undefined ? "…" : doc ? `Versione ${doc.version} · in vigore dal ${doc.effective_date || "—"}` : "In preparazione"}</p>
      </div>
      {doc && to && <Link to={to} target="_blank" className="text-sm text-[#8C532B] font-semibold">Apri</Link>}
    </div>
  );

  return (
    <div className="bg-white rounded-xl border border-[#E5DEC9] p-6" data-testid="gestore-legal">
      <h3 className="font-display text-lg text-[#1B3B2B] mb-2">Documenti legali Equiro</h3>
      <Row label="Termini e Condizioni" doc={terms} to="/termini" />
      <Row label="Informativa Privacy" doc={privacy} to="/privacy" />
      <Row label="DPA" doc={dpa} to={null} />
      <p className="text-xs text-[#5F6B64] mt-4" data-testid="gestore-legal-acc">Le tue accettazioni registrate: {acc.length}</p>
    </div>
  );
}
